import { FocusMonitor } from '@angular/cdk/a11y';
import { CdkConnectedOverlay } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatButton, MatChip, MatInput, MatSelect } from '@angular/material';
import { List } from 'immutable';
import { merge, Observable } from 'rxjs';
import { filter, map, mapTo } from 'rxjs/operators';
import { runInThisContext } from 'vm';
import { Device, OrderDto, ShipmentDetail, Sim } from '../models/OrderDto';
export interface Replacements{
  imeis: any[];
  newImeis: any[];
}
export interface Refunds{
  imeis: any[];
}

export class Result{
  private _replacements: Replacements;
  private _refunds: Refunds;

  constructor(private replacement: Replacements, private refund: Refunds){
    this._refunds=refund;
    this._replacements= replacement;
  }
    public get replacements(): Replacements {
        return this._replacements;
    }

    public set replacements(replacements: Replacements) {
        this._replacements = replacements;
    }

    public get refunds(): Refunds {
        return this._refunds;
    }

    public set refunds(refunds: Refunds) {
        this._refunds = refunds;
    }
 

}

@Component({
  selector: 'app-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropDownComponent implements OnInit {
  isPanelVisible$:Observable<boolean>;
  isPanelHidden$: Observable<boolean>;
  showPanel$: Observable<boolean>;

  @ViewChild(MatChip, {read: ElementRef, static:true}) 
  private matButton:ElementRef;

  @ViewChild(CdkConnectedOverlay, {static:true})
  private connectedOverlay: CdkConnectedOverlay



  @Input()
  orders: OrderDto
  @Input()
  logStatus

  @Input()
  replacementapprove:List<string>
  @Input()
  replacementinitiate:List<string>
  @Input()
  refundapproved:List<string>
  @Input()
  refundinitiate:List<string>
  @Input()
  shipmentDetail: ShipmentDetail;


  result: Result= new Result({imeis: [],newImeis: []},{imeis:[]});

  constructor(private focuMonitor: FocusMonitor) { }

  ngOnInit() {
   
    this.isPanelVisible$=this.focuMonitor.monitor(this.matButton).pipe(filter(focussed=> !!focussed), mapTo(true));
    this.isPanelHidden$=this.connectedOverlay.backdropClick.pipe(mapTo(false));
    this.showPanel$=merge(this.isPanelVisible$, this.isPanelHidden$);
  }

}
